export enum Genders {
  Male = 'male',
  Female = 'female',
}
